import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Icon } from '../../../../core/components/atoms/Icon';
import React from 'react';
import { planoAdaptativoMenuItems } from '../../../../core/templates/baseApp/components/bottomMenu/menuItems';
import { IMenuItem } from '../../../../core/templates/baseApp/components/menuBar/menuItems';

interface IPASidebarProps {
  show: boolean;
  isClosed: boolean;
  onClose: () => void;
}

const PASidebar: React.FC<IPASidebarProps> = ({ show, isClosed, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { UUID, scheduleId } = useParams();

  const isActive = (path?: string) => {
    if (!path) return false;

    return location.pathname.includes(path);
  };

  const handleNavigate = (path?: string) => {
    if (!path) return;
    navigate(`/plano-adaptativo/${UUID || scheduleId}/${path}`);
  };

  const removeMinhaArea = (item: IMenuItem) => item.label !== 'Minha Área';

  if (!show) return null;

  return (
    <div
      className={` hidden shrink-0 flex-col gap-2 rounded-l-[32px] bg-card-color-default px-4 py-8 pr-4 shadow-level-2 transition-all duration-300 dark:bg-brand-color-primary-dark md:flex ${isClosed ? 'w-[64px]' : 'w-[280px]'}`}
    >
      <div
        className={`hidden w-full md:flex ${isClosed ? 'flex-col' : 'flex-row justify-between'} items-center`}
      >
        {!isClosed && (
          <Typography type='title' size='h3'>
            Menu
          </Typography>
        )}
        <Icon
          type='material'
          Icon={isClosed ? 'chevron_right' : 'chevron_left'}
          className='cursor-pointer text-mono-color-darkest dark:text-mono-color-medium'
          onClick={onClose}
        />
      </div>
      {planoAdaptativoMenuItems.filter(removeMinhaArea).map((item) => (
        <MenuItem
          isClosed={isClosed}
          key={item.label}
          label={item.label}
          icon={
            <Icon
              type='material'
              Icon={item.icon}
              className={`text-md text-mono-color-darkest ${isActive(item.href) ? 'text-mono-color-white dark:text-mono-color-darkest' : ''}`}
            />
          }
          isActive={isActive(item.href)}
          onClick={() => handleNavigate(item.href)}
        />
      ))}
    </div>
  );
};

export default PASidebar;

const MenuItem = ({
  label,
  icon,
  isActive,
  onClick,
  isClosed,
}: {
  label: string;
  icon: React.ReactNode;
  isActive: boolean;
  isClosed: boolean;
  onClick?: () => void;
}) => {
  return (
    <div
      onClick={onClick}
      className={`flex cursor-pointer flex-row items-center gap-2 rounded-sm px-2 py-1 text-mono-color-medium ${isActive ? 'bg-color-brand-primary' : ''}`}
    >
      {icon}
      {!isClosed && (
        <Typography
          type='p'
          size='small'
          className={`${isActive ? 'text-[#FFF]' : 'text-mono-color-darkest'} text-md`}
        >
          {label}
        </Typography>
      )}
    </div>
  );
};
